module.exports = __webpack_public_path__ + "static/media/front.b116c359.svg";